var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "categroyDialog-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "分类",
            visible: _vm.showCategoryDialog,
            width: "400px"
          },
          on: { close: _vm.btnCancel }
        },
        [
          _vm._l(_vm.customCateList, function(cateItem) {
            return _c(
              "span",
              {
                key: cateItem.shopDecorateId,
                staticClass: "cate-item",
                on: {
                  click: function($event) {
                    return _vm.cateItemclick(cateItem)
                  }
                }
              },
              [_vm._v(_vm._s(cateItem.name))]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }